import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUserId } from '../auth/authSlice';
import { useUserActionOcurrsMutation } from '../../services/accountsApi';

function RouteChangeReporter() {
  const location = useLocation();
  const userId = useSelector(selectCurrentUserId);
  const [sendUserActionOcurrs] = useUserActionOcurrsMutation();

  useEffect(() => {
    if (userId) {
      sendUserActionOcurrs({
        userId: userId,
        action: "PAGE_VISIT",
        dataName: "URL",
        dataValue: location.pathname + location.search
      });
    }
  }, [location.pathname, location.search, userId, sendUserActionOcurrs]);

  return null;
}

export default RouteChangeReporter;
